import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./vuex";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import axios from "axios";
import VueAxios from "vue-axios";
import VueAwesomeSwiper from "vue-awesome-swiper";

import VueTypedJs from "vue-typed-js";

import { toMoney } from '@/utils/utils'

Vue.use(VueTypedJs);
Vue.filter('toMoney', toMoney)

// main.js

//引入阿里云图标库
import "@/assets/icon/iconfont.css";

import "codemirror/lib/codemirror.css";

import "codemirror/addon/hint/show-hint.css";
import elTableInfiniteScroll from "el-table-infinite-scroll";

Vue.config.productionTip = false;
Vue.use(elTableInfiniteScroll);
// import style
import "swiper/swiper-bundle.css";
Vue.use(VueAwesomeSwiper);
//配置分页器
import { Swiper as SwiperClass, Pagination } from "swiper";
SwiperClass.use([Pagination]);
// permission  权限控制
import "./permission";
// 自定义指令
import "./directives/";
import "./styles/index.scss";

//引入引导页面
import Driver from "driver.js";
import "driver.js/dist/driver.min.css";

import mavonEditor from "mavon-editor";
import "mavon-editor/dist/css/index.css";
// use
Vue.use(mavonEditor);

Vue.prototype.$driver = new Driver({
  doneBtnText: "完成", // Text on the final button
  closeBtnText: "关闭", // Text on the close button for this step
  stageBackground: "#fff", // Background color for the staged behind highlighted element
  nextBtnText: "下一步", // Next button text for this step
  prevBtnText: "上一步", // Previous button text for this step
});

// 引入echarts
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
Vue.use(codemirror);

Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;
Vue.use(VueAxios, axios);


//定义全局变量
Vue.prototype.measurementId = function () {
  var measurementId = "G-5MTRD26299";
  return measurementId;
};

Vue.prototype.apiSecret = function () {
  var apiSecret = "8T3DHkdfTGytDgKzIMdyEQ";
  return apiSecret;
};

import { log } from '@/utils/prettyConsole'
window.log = log;

// 正式环境清除所有console.log

if (process.env.NODE_ENV === "production") {
  if (window) {
    window.console.log = function () { };
  }
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");


console.log('当前环境', process.env.VUE_APP_BASE_URL)